import React from 'react';
import PropTypes from 'prop-types';

import ModuleDuoItem from './duo-module-item';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleDuo = ({
    card1Title,
    card1Body,
    card1CtaLabel,
    card1CtaLink,
    card1Modal,
    card1EyebrowIcon = {},
    card1EyebrowTitle,
    card1Image = {},
    card2Title,
    card2Body,
    card2CtaLabel,
    card2CtaLink,
    card2Modal,
    card2EyebrowIcon = {},
    card2EyebrowTitle,
    card2Image = {},
    headerCopy,
    title,
    variant,
    parent
}) => {
    return (
        <div className={`bg-white relative ${parent === 'Home' ? 'py-40 md:py-50' : parent === 'Detail' ? 'py-20 md:py-30' : 'py-40 md:py-60'}`}>
            <div className='layout-container'>

                <div className='bg-white'>
                    <div className='flex flex-col px-10 sm:px-5 md:px-10 w-full sm:w-1/2 md:w-7/12'>
                        <p className='type-style-3 pr-10 sm:pr-0'>
                            {title}
                        </p>
                        {headerCopy && (
                            <p className='type-style-5 pr-10 sm:pr-0 mt-5 md:mt-10'>
                                {headerCopy}
                            </p>
                        )}
                    </div>
                    <div className='px-10 sm:px-5 md:px-10 mt-20 sm:mt-25 md:mt-40 grid sm:grid-cols-2 gap-y-20 sm:gap-x-10 md:gap-x-20'>
                        <ModuleDuoItem
                            body={card1Body}
                            cardTitle={card1Title}
                            ctaLabel={card1CtaLabel}
                            ctaLink={card1CtaLink}
                            eyebrowIcon={card1EyebrowIcon}
                            eyebrowTitle={card1EyebrowTitle}
                            image={card1Image}
                            modal={card1Modal}
                            variant={variant}/>
                        <ModuleDuoItem
                            body={card2Body}
                            cardTitle={card2Title}
                            ctaLabel={card2CtaLabel}
                            ctaLink={card2CtaLink}
                            eyebrowIcon={card2EyebrowIcon}
                            eyebrowTitle={card2EyebrowTitle}
                            image={card2Image}
                            modal={card2Modal}
                            variant={variant}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleDuo.propTypes = {
    card1Title: PropTypes.string,
    card1Body: PropTypes.string,
    card1CtaLabel: PropTypes.string,
    card1CtaLink: PropTypes.string,
    card1Modal: PropTypes.object,
    card1EyebrowIcon: PropTypes.object,
    card1EyebrowTitle: PropTypes.string,
    card1Image: PropTypes.object,
    card2Title: PropTypes.string,
    card2Body: PropTypes.string,
    card2CtaLabel: PropTypes.string,
    card2CtaLink: PropTypes.string,
    card2Modal: PropTypes.object,
    card2EyebrowIcon: PropTypes.object,
    card2EyebrowTitle: PropTypes.string,
    card2Image: PropTypes.object,
    headerCopy: PropTypes.string,
    title: PropTypes.string,
    parent: PropTypes.string,
    variant: PropTypes.string,
};

export default ModuleDuo;
